import React from "react";
import AddGiftButton from "../../button/AddGiftButton";

type Props = {
    onGiftAdded?: () => void;
};

const CreateGift = ({ onGiftAdded }: Props) => {
    return <AddGiftButton onGiftAdded={onGiftAdded} />;
};

export default CreateGift;
